var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-body--layers" },
    [
      _c("b-checkbox", [_vm._v("\n    Select All\n  ")]),
      _vm._v(" "),
      _vm._l(_vm.tree, function (folder) {
        return _c("FigmaFolderLayer", {
          key: folder.data.name,
          attrs: { node: folder },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }